import type { FC } from "react";
import { useSnackbar } from "notistack";
import { FormLabel, Stack, Tooltip, Typography } from "@mui/material";
import type { CustomerBankAccounts } from "./customersApi";

function accountsToList(
  accounts: CustomerBankAccounts | undefined,
): { readonly label: string; readonly number: string }[] {
  if (!accounts) {
    return [];
  }
  const entries: { readonly label: string; readonly number: string | undefined }[] = [
    { label: "Przezmorze PLN", number: accounts.przezmorze.PLN },
    { label: "Przezmorze EUR", number: accounts.przezmorze.EUR },
    { label: "B2BHotels PLN", number: accounts.b2bHotels?.PLN },
    { label: "B2BHotels EUR", number: accounts.b2bHotels?.EUR },
  ];
  return entries.filter((a): a is { readonly label: string; readonly number: string } => !!a.number);
}

interface BankAccountsProps {
  readonly accounts: CustomerBankAccounts | undefined;
}

export const BankAccounts: FC<BankAccountsProps> = ({ accounts }) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyToClipboard = (accountNumber: string) => {
    navigator.clipboard.writeText(accountNumber);
    enqueueSnackbar(`Skopiowano numer konta: ${accountNumber}`, { variant: "success" });
  };
  const accountsList = accountsToList(accounts);
  if (accountsList.length === 0) {
    return <></>;
  }
  return (
    <div style={{ width: "fit-content" }}>
      <FormLabel>Numery kont bankowych</FormLabel>
      <Stack>
        {accountsList.map(({ label, number }) => {
          return (
            <Stack
              direction="row"
              key={label}
              spacing={1}
              sx={{
                alignItems: "center",
              }}
            >
              <FormLabel sx={{ minWidth: "140px", textAlign: "right", pr: 1 }}>{label}:</FormLabel>
              <Tooltip title="Kopiuj do schowka">
                <Typography
                  variant="body2"
                  onClick={() => handleCopyToClipboard(number)}
                  style={{ cursor: "pointer" }}
                  sx={{
                    whiteSpace: "pre",
                    fontFamily: "monospace",
                  }}
                >
                  {number}
                </Typography>
              </Tooltip>
            </Stack>
          );
        })}
      </Stack>
    </div>
  );
};
